define('taoQtiItem/qtiItem/core/choices/AssociableHotspot',['taoQtiItem/qtiItem/core/choices/Hotspot'], function(QtiHotspot){
    var QtiAssociableHotspot = QtiHotspot.extend({
        qtiClass : 'associableHotspot'
    });
    return QtiAssociableHotspot;
});



